module.exports = __webpack_public_path__ + "static/media/Sassuolo.68f9100c.jpg";